import { Game } from "../types/game";
import { Competition, GameRules } from "../types/competition";

function resolvedHandicapConfig(game: Game) {
  const sourceType = game.handicapSourceType ?? "game_rule";

  if (sourceType === "custom_rule") {
    return {
      handicapSourceType: "custom_rule" as const,
      handicapSourceCompetitionId: game.handicapSourceCompetitionId,
      handicapAdjustmentMode: game.handicapAdjustmentMode,
    };
  }

  if (sourceType === "whs_hi") {
    return { handicapSourceType: "whs_hi" as const };
  }

  return { handicapSourceType: "game_rule" as const };
}

/** Show Handicap source whenever a game rule is selected (GameSetup also requires competitionId). */
export function showGameSetupHandicapSource(competition: Competition | null | undefined): boolean {
  return !!competition;
}

/** External custom listings (e.g. Smerffs By Papa) only work when the game scoring rule is custom. */
export function supportsExternalCustomHandicapListing(competition: Competition | null | undefined): boolean {
  return competition?.type === GameRules.CUSTOM;
}

export function gameShowsHandicapAdjustment(game: Game): boolean {
  const config = resolvedHandicapConfig(game);
  if (config.handicapAdjustmentMode === "apply_source_rules") return true;
  if (config.handicapAdjustmentMode === "none") return false;

  const rules = game.competition?.handicapRules;
  if (!rules) return false;

  const isTeamGame = game.competition?.playingRules?.playingAs === "team";
  if (isTeamGame) return false;

  return !!(rules.adjustHandicapOnResult || rules.adjustHandicapOnPoints);
}

export function normalizeGameHandicapPayload(
  game: Pick<Game, "handicapSourceType" | "handicapSourceCompetitionId" | "handicapAdjustmentMode">,
) {
  const sourceType = game.handicapSourceType ?? "game_rule";
  if (sourceType === "game_rule") {
    return { handicapSourceType: "game_rule" as const };
  }
  if (sourceType === "whs_hi") {
    return { handicapSourceType: "whs_hi" as const };
  }
  return {
    handicapSourceType: "custom_rule" as const,
    handicapSourceCompetitionId: game.handicapSourceCompetitionId,
    handicapAdjustmentMode: game.handicapAdjustmentMode,
  };
}
